import { memo } from 'react'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@components/ui/collapsible'
import { Button } from '@components/ui/button'
import { ChevronDown } from 'lucide-react'
import { AnimatePresence, motion } from 'framer-motion'

// Improved animation variants
const expandCollapse = {
  initial: { height: 0, opacity: 0 },
  animate: {
    height: 'auto',
    opacity: 1,
    transition: {
      height: { duration: 0.1 },
      opacity: { duration: 0.1 },
    },
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: {
      height: { duration: 0.05 },
      opacity: { duration: 0.05 },
    },
  },
}

const CollapsibleSection = memo(({ title, icon: Icon, isOpen, onToggle, children, showChevron = true }) => {
  return (
    <Collapsible open={isOpen} onOpenChange={onToggle}>
      <CollapsibleTrigger asChild>
        <Button
          variant="outline"
          className="w-full h-12 flex items-center justify-center gap-2 text-gray-700 hover:text-gray-900 border-gray-300 hover:bg-gray-50 transition-all duration-200 rounded-md shadow-sm hover:shadow-md"
        >
          <Icon className="h-5 w-5" />
          <span>{title}</span>
          {showChevron && (
            <ChevronDown className={`h-5 w-5 ml-2 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
          )}
        </Button>
      </CollapsibleTrigger>
      <AnimatePresence mode="wait">
        {isOpen && (
          <CollapsibleContent forceMount className="mt-2 overflow-hidden">
            <motion.div
              className="bg-gray-50 p-5 rounded-md border border-gray-200 shadow-inner"
              variants={expandCollapse}
              initial="initial"
              animate="animate"
              exit="exit"
              layout
            >
              {children}
            </motion.div>
          </CollapsibleContent>
        )}
      </AnimatePresence>
    </Collapsible>
  )
})

CollapsibleSection.displayName = 'CollapsibleSection'

export default CollapsibleSection
